module.exports = __webpack_public_path__ + "static/warforged-ready-to-robber-lightning-train-dbcc99e2559bdec3908987e4d2fe61f0.jpeg";